/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, ElementRef, Host, Optional, Renderer2 } from "@angular/core";
import { UiButtonGroupComponent } from "@webapp/ui/button/components/button-group/button-group.component";
import { NzDropdownButtonDirective } from "ng-zorro-antd/dropdown";

@Directive({
  selector: "[ui-button][ui-dropdown]",
})
export class UiDropdownButtonDirective extends NzDropdownButtonDirective {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  public constructor(renderer: Renderer2, @Host() @Optional() uiButtonGroupComponent: UiButtonGroupComponent, elementRef: ElementRef) {
    super(renderer, uiButtonGroupComponent, elementRef);
  }
}
